<template>
  <div class="notesInfoContent">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="notes">
        <template #title>
          <span>
            <img src="../../assets/svg/notesIcon.svg" alt="" />
            回复
          </span>
        </template>
        <div>
          <el-form
            ref="notesForm"
            :model="form"
            :rules="formRules"
            label-width="155px"
          >
            <el-form-item label="改进措施图片" style="margin-top: 0px;">
              <file-upload-list
                :fileList="form.improvementImageList || []"
              ></file-upload-list>
            </el-form-item>
            <el-form-item label="责任归属">
              <div class="problemInput">
                {{ form.responsibilityName }}
              </div>
            </el-form-item>
            <el-form-item label="是否接受索赔">
              <div class="problemInput">
                {{ form.acceptClaim }}
              </div>
            </el-form-item>
            <el-form-item label="断点前物料处理意见">
              <div class="problemDesInfo">
                {{ form.materialHandlingOpinion }}
              </div>
            </el-form-item>
            <el-form-item label="新物料断点批次号">
              <div class="problemInput">
                {{ form.breakpointBatchNo }}
              </div>
            </el-form-item>
            <el-form-item label="新物料断点时间">
              <div class="problemInput">
                {{ form.breakpointTime }}
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: "notesInfo",
  data() {
    return {
      activeNames: ["notes"], // 全部展开
      form: {},
    };
  },
  props: {
    demandInfo: {
      type: [Array, Object],
      // default:() => []
    },
    authStatus: {
      type: Boolean,
    },
  },
  computed: {
    formRules() {
      const isRequired = !this.authStatus;
      return {
        customerDemand: [
          { required: isRequired, message: "请输入客户诉求", trigger: "blur" },
        ],
      };
    },
  },
  async created() {
    this.getDemandInfo();
  },
  methods: {
    // 获取数据
    getDemandInfo() {
      if (this.demandInfo) {
        this.form = this.demandInfo;
      }
    },
    // 监听失去焦点
    inputBlur(val, type) {
      this.form[type] = val;
      this.$emit("update:demandInfo", this.form);
    },
    validateForm() {
      return this.$refs["notesForm"].validate()
        .then(() => ({ isValid: true, object: null }))
        .catch(errors => ({ isValid: false, object: errors }));
    },
  },
};
</script>
